<!-- 赛事规格 -->
<template>
  <div>
    <event-head></event-head>
    <normal-card title="费用设置" class="mt-5">
      <div class="infoPage">
        <el-form label-width="120px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="报名费用：">
                <el-input class="inputPrice" placeholder="请输入" v-model="stepFourForm.entryFee">
                  <i slot="suffix" class="dw">/队</i></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="保证金:">
                <el-input class="inputPrice" placeholder="请输入" v-model="stepFourForm.earnestMoney">
                  <i slot="suffix" class="dw">/队</i></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="报名方式：">
                <el-select v-model="stepFourForm.entryType">
                  <el-option v-for="item in entryType" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="比赛场数：">
                <el-input class="inputPrice" placeholder="请输入比赛场数" v-model="stepThreeForm.totalGame">
                  <i slot="suffix" class="dw">场</i></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
        </el-form>
      </div>
    </normal-card>
    <normal-card title="数量设置" class="mt-5">
      <div class="infoPage">
        <el-form label-width="120px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="分组数量：">
                <el-input class="inputPrice" placeholder="请输入分组数量" v-model="stepThreeForm.teamGroupCount">
                  <i slot="suffix" class="dw">组</i></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="球队数量:">
                <el-input class="inputPrice" placeholder="请输入球队数量" v-model="stepThreeForm.maxSignTeam">
                  <i slot="suffix" class="dw">队</i></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="球员数量：">
                <el-input class="inputPrice" placeholder="请输入球员数量" v-model="stepThreeForm.teamPlayerCount">
                  <i slot="suffix" class="dw">/队</i></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="比赛场数：">
                <el-input class="inputPrice" placeholder="请输入比赛场数" v-model="stepThreeForm.totalGame">
                  <i slot="suffix" class="dw">场</i></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </normal-card>

    <normal-card title="类型设置" class="mt-5">
      <div class="infoPage">
        <el-form label-width="120px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="赛事类型:">
                <el-input v-model="stepOneForm.matchType" class="inputPrice" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="赛制类型:">
                <el-select v-model="stepThreeForm.matchFormat">
                  <el-option v-for="item in matchFormat" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="场制类型:">
                <el-select v-model="stepThreeForm.matchFieldType">
                  <el-option v-for="item in matchType" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="年龄类型:">
                <el-select v-model="stepThreeForm.matchGroup">
                  <el-option v-for="item in peopleType" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </normal-card>

    <normal-card title="地点设置" class="mt-5">
      <div class="infoPage">
        <div class="overviewCommand_detail">
          <el-form label-width="120px">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="举办城市:">
                  <el-cascader v-model="stepOneForm.city" :options="province.city" clearable></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="球场名称:">
                  <el-input class="inputPrice" v-model="stepOneForm.stadium" placeholder="请输入球场名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="球场地址:">
                  <template>
                    <div style="display: flex;">
                      <el-input v-model="stepOneForm.stadiumAddress" :disabled="true" style="width: 500px;"></el-input>
                      <el-button type="primary" style="margin-left: 10px" @click="changePosition">地图选点</el-button>
                    </div>
                  </template>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <!-- 地图弹窗 -->
        <el-dialog :visible.sync="showMapDialog" v-if="showMapDialog" title="地图选点">
          <Map @map-submit="mapSubmit" :address="stepOneForm.stadiumAddress"></Map>
        </el-dialog>
      </div>
    </normal-card>

    <div class="btn-com">
      <el-button class="save-btn" @click="handleSave">保存
      </el-button>
    </div>
  </div>
</template>

<script>
import Map from '@/views/eventManage/components/Map';
import province from "@/apidata/province.json";
import EventHead from '@/common/components/eventHead/EventHead';
import normalCard from '@/common/components/normal/NormalCard';
export default {
  components: {
    Map,
    EventHead,
    normalCard
  },
  /**
   * 表单属性采用配置方式， 1:输入框  2:下拉选择  3:图片上传  4:日期选择
   */
  data() {
    return {
      province: province,
      matchList: [],
      title: '',
      dialogVisible: false,
      showMapDialog: false,
      peopleType: [{
          value: 1,
          label: '成人组',
        },
        {
          value: 2,
          label: '少儿组',
        },
        {
          value: 5,
          label: 'U5',
        },
        {
          value: 18,
          label: 'U18组',
        },
        {
          value: 30,
          label: '30+组',
        },
        {
          value: 35,
          label: '35+组',
        },
        {
          value: 40,
          label: '40+组',
        },
        {
          value: 50,
          label: '50+组',
        }],
      matchFormat: [
        {
          value: 1,
          label: '联赛制',
        },
        {
          value: 3,
          label: '杯赛制',
        },
      ],
      matchType: [
        {
          value: 5,
          label: '五人制',
        },
        {
          value: 6,
          label: '六人制',
        },
        {
          value: 7,
          label: '七人制',
        },
        {
          value: 8,
          label: '八人制',
        },
        {
          value: 9,
          label: '九人制',
        },
        {
          value: 10,
          label: '十人制',
        },
        {
          value: 11,
          label: '十一人制',
        },
      ],
      entryType: [{
        value: 0,
        label: '缴费制',
      },
      {
        value: 1,
        label: '注册制',
      }],
      matchGroup: [
        {
          value: 1,
          label: '成人组',
        },
        {
          value: 2,
          label: 'U8组',
        },
        {
          value: 3,
          label: 'U12组',
        },
        {
          value: 4,
          label: 'U15组',
        },
        {
          value: 5,
          label: '4个分组',
        },
      ],
      stepOneForm: {
        matchLogo: '',
        matchTitle: '',
        organizer: '',
        city: '',
        stadium: '',
        stadiumAddress: '',
        matchType: '',
        beginDate: '',
        endDate: '',
        signBeginDate: '',
        signEndDate: '',
      },
      stepOneColumns: [
        { title: '赛事logo（建议1:1上传）：', type: 3, code: 'matchLogo', editable: true },
        { title: '赛事名称：', type: 1, code: 'matchTitle', editable: true },
        { title: '主办单位：', type: 1, code: 'organizer', editable: true },
        { title: '举办城市：', type: 1, code: 'city', editable: true },
        { title: '承办球场：', type: 1, code: 'stadium', editable: true },
        { title: '球场地址：', type: 1, code: 'stadiumAddress', editable: false },
        {
          title: '赛事类型：',
          type: 2,
          code: 'matchType',
          propertyOptionList: [
          {
              value: 1,
              label: '公开赛',
            },
            {
              value: 2,
              label: '过人王',
            },
            {
              value: 3,
              label: '院校赛',
            },
            {
              value: 4,
              label: '青训赛',
            }
          ],
        }
      ],
      stepThreeForm: {
        matchFormat: '',
        matchType: '',
        matchGroup: '',
        teamGroupCount: '',
        teamPlayerCount: '',
        totalGame: '',
        maxSignTeam: ''
      },
      stepFourForm: {
        contact: '',
        entryType: '',
        entryFee: 0,
        earnestMoney: 0,
        minSignTeam: 0,
      },
      matchData: {},
      matchInfo: {},
      userMatch: [
        {
          value: 1,
          label: '公开赛',
        },
        {
          value: 2,
          label: '过人王',
        },
        {
          value: 3,
          label: '院校赛',
        },
        {
          value: 4,
          label: '青训赛',
        },
        {
          value: 5,
          label: '球场联赛',
        },
      ],
      userMatchType: ""
    };
  },
  mounted() {
    if (localStorage.getItem('matchId')) {
      this.matchInfo = localStorage.getItem('currentMatchId') ? JSON.parse(localStorage.getItem('currentMatchId')) : {};
      this.getMatchDetail()
    } else {
      this.$confirm('暂无赛事！！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
    }
  },
  methods: {
    // 获取赛事详情
    async getMatchDetail() {
      const { res } = await this.$http.get(`/Match/MatchInfo/${this.matchInfo.matchId}`);
      this.stepOneForm = res.data.info;
      this.stepThreeForm = res.data.formatInfo;
      this.stepFourForm = res.data.extInfo;
      this.stepOneForm.matchType = this.userMatch.find(item => {
        return item.value = this.stepOneForm.matchType
      }).label;
    },
    // 保存
    handleSave() {
      if (Array.isArray(this.stepOneForm.city)) {
        this.stepOneForm.city = this.stepOneForm.city[1]
      }
      if (this.stepOneForm.matchType == '公开赛') {
        this.matchData.matchType = 1
      } if (this.stepOneForm.matchType == '过人王') {
        this.matchData.matchType = 2
      }if (this.stepOneForm.matchType == '院校赛') {
        this.matchData.matchType = 3
      }if (this.stepOneForm.matchType == '青训赛') {
        this.matchData.matchType = 4
      }
      // this.stepOneForm.matchType = this.userMatch.find(item => {
      //   return item.label ===  this.stepOneForm.matchType 
      // }).value;
      // this.matchData.infoRequest = this.stepOneForm
      // this.matchData.formatInfoReqeust = this.stepThreeForm
      // this.matchData.extInfoRequest = this.stepFourForm
      this.matchData.maxSignTeam = this.stepThreeForm.maxSignTeam;
      this.matchData.totalGame = this.stepThreeForm.totalGame;
      this.matchData.teamPlayerCount = this.stepThreeForm.teamPlayerCount;
      this.matchData.entryFee = this.stepFourForm.entryFee;
      this.matchData.earnestMoney = this.stepFourForm.earnestMoney;
      this.matchData.entryType = this.stepFourForm.entryType;
      this.matchData.matchId = this.stepOneForm.matchId;
      this.matchData.matchTitle = this.stepOneForm.matchTitle;
      this.matchData.matchLogo = this.stepOneForm.matchLogo;
      this.matchData.matchPoster = "";
      this.matchData.organizer = this.stepOneForm.organizer;
      this.matchData.stadium = this.stepOneForm.stadium;
      this.matchData.stadiumAddress = this.stepOneForm.stadiumAddress;
      this.matchData.longitude = this.stepOneForm.longitude;
      this.matchData.latitude = this.stepOneForm.latitude;
      this.matchData.beginDate = this.stepOneForm.beginDate;
      this.matchData.endDate = this.stepOneForm.endDate;
      this.matchData.city = this.stepOneForm.city;
      // this.matchData.matchType = this.stepOneForm.matchType;
      this.matchData.contact = this.stepFourForm.contact;
      this.matchData.matchFormat = this.stepThreeForm.matchFormat;
      this.matchData.matchFieldType = this.stepThreeForm.matchFieldType;
      this.matchData.matchGroup = this.stepThreeForm.matchGroup;
      console.log(11111, this.matchData)
      this.$confirm('请核实信息，确定要发布改赛事吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const { res } = await this.$http.post('/Match/SaveMatch', this.matchData);
        if (res.isSuccess) {
          this.$showSuccess('发布成功');
          this.dialogVisible = false
          this.getMatchDetail();
        }
      });
    },

    changePosition() {
      this.showMapDialog = true;
    },
    // 选择地址
    mapSubmit(location, address) {
      console.log(location, address);
      this.stepOneForm.stadiumAddress = address;
      this.stepOneForm.longitude = location.lng;
      this.stepOneForm.latitude = location.lat;
      this.showMapDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.infoPage {
  width: 100%;
  height: 100%;
  margin-top: 40px;

  .inputPrice {
    width: 200px;
  }
}

/deep/.el-input--small .el-input__inner {
  color: #e9e9e9;
}

.promptText {
  width: 90%;
  color: #2ba245;
  opacity: 0.6;
}

.wpct30 {
  width: 30%;
}

.btn-com {
  display: flex;
  justify-content: center;
  margin-top: 30px;

  .save-btn {
    color: #fff;
    background: rgb(51, 64, 84);
    width: 120px;
  }
}
</style>